import { defineStore } from 'pinia'
import { ref } from 'vue'
import { api, ApiError } from '../api/client'
import { useBillingStore } from './billing'
import type { User, Workspace } from '../api/types'

export const useSessionStore = defineStore('console-session', () => {
  const user = ref<User | null>(null)
  const workspaces = ref<Workspace[]>([])
  const initialized = ref(false)
  const roles = ref<Record<string, string>>({})
  const platformDenied = ref(false)
  async function restore() {
    try { user.value = await api.me(); platformDenied.value = false }
    catch (error) {
      if (!(error instanceof ApiError) || error.status !== 401) throw error
      user.value = null
    }
    initialized.value = true
  }
  async function login(email: string, password: string) {
    await api.login(email, password)
    await restore()
    if (!user.value) throw new Error('Сессия не сохранилась. Для локального HTTP включите DEBUG=True в backend.')
  }
  async function logout() {
    await api.logout()
    user.value = null
    workspaces.value = []; roles.value = {}; useBillingStore().reset()
  }
  async function loadWorkspaces() { workspaces.value = await api.workspaces() }
  async function loadRole(id: string) {
    const workspace = workspaces.value.find(item => item.id === id)
    if (user.value?.is_superuser || workspace?.owner_id === user.value?.id) { roles.value[id] = user.value?.is_superuser ? 'admin' : 'owner'; return }
    const userId = user.value?.id
    const members = await api.members(id)
    if (user.value?.id === userId) roles.value[id] = members.find(item => item.user_id === userId)?.role || 'member'
  }
  return { roles, platformDenied, loadRole, user, workspaces, initialized, restore, login, logout, loadWorkspaces }
})

